import React, { useEffect, useState } from "react";
import API from "utils/API";
import { currencyFormat } from "utils/columns";
import ReactStrapTable from "components/reactStrapTable";
import CellOptions from "components/reactStrapTable/components/CellOptions";
import CellEditRender from "components/reactStrapTable/components/CellEditRender";

let tableDataBackup = [],
  rowForEdit = {},
  selectedCoveredEntity = null;

const ProvidersTable = (props) => {
  const {
    data,
    totalSize,
    onPageChange,
    loading,
    apiFilter,
    formReset,
    onSearchColumnFilters = () => "",
    onExport,
    setLoading,
    refetch,
    coveredEntityTenantID,
  } = props;
  selectedCoveredEntity = coveredEntityTenantID;
  tableDataBackup = data;
  const [filters, setFilters] = useState(apiFilter);
  const [tableData, setTableData] = useState(tableDataBackup);
  const [reset, setReset] = useState(false);

  useEffect(() => {
    setFilters(apiFilter);
  }, [apiFilter]);

  useEffect(() => {
    setTableData(data);
    tableDataBackup = data;
  }, [data]);

  useEffect(() => {
    setReset((pre) => !pre);
    setFilters({
      currentPage: 1,
      pageSize: 10,
      orderBy: "",
      order: "",
      filters: [],
    });
  }, [formReset]);

  const updateRowValue = (value, col) => {
    const tempRow = { ...rowForEdit };
    tempRow[col] = value;
    rowForEdit = tempRow;
  };

  const saveUpdateRow = async () => {
    setLoading(true);
    const tenantID = selectedCoveredEntity;
    let payload = { ...rowForEdit };
    payload.suppressFlag =
      payload.suppressFlag === null ? "N" : payload.suppressFlag;
    payload.eligibleFlag =
      payload.eligibleFlag === null ? "N" : payload.eligibleFlag;
    delete payload.isEdit;
    try {
      const result = await API.post(`/${tenantID}/CEProvider/update`, payload);
      if (result) {
        setLoading(false);
        refetch();
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const editRow = (rowData, isEdit = true) => {
    let tempData = [...tableDataBackup];
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.providerID === rowData?.providerID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });
    tableDataBackup = tempData;
    setTableData(tempData);
  };

  const cellRenderEdit = (row) => {
    return <CellOptions row={row} onEdit={editRow} onSave={saveUpdateRow} />;
  };

  const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {
    return (
      <CellEditRender
        row={row}
        alwaysEditableCheckbox={alwaysEditableCheckbox}
        hasEditable={col.edit}
        columnName={col.dataField}
        formatterType={formatterType}
        onChange={updateRowValue}
      />
    );
  };

  let columns = [
    {
      dataField: "edit",
      text: "Options",
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 80,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "providerNPI",
      text: "NPI#",
      sort: true,
      width: 90,
      show: true,
      inputType: "text",
    },
    {
      dataField: "providerFirstName",
      text: "Provider First Name",
      sort: true,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col),
      edit: true,
    },
    {
      dataField: "providerLastName",
      text: "Provider Last Name",
      sort: true,
      width: 140,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col),
      edit: true,
    },
    {
      dataField: "eligibleFlag",
      text: "Eligible Flag",
      sort: true,
      width: 140,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col, "checkbox"),
      edit: true,
    },
    {
      dataField: "comments",
      text: "Comments",
      sort: true,
      width: 140,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col, "textarea"),
      edit: true,
    },
    {
      dataField: "faxNumber",
      text: "Fax Number",
      sort: true,
      width: 140,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col),
      edit: true,
    },
    {
      dataField: "suppressFlag",
      text: "Suppress Flag",
      sort: true,
      width: 140,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col, "checkbox", true),
      edit: true,
    },

    {
      dataField: "providerSpecialty",
      text: "Provider Specialty",
      sort: true,
      width: 130,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col),
      edit: true,
    },
    {
      dataField: "opportunityAmount",
      text: "Opportunity Amount",
      sort: true,
      width: 120,
      show: true,
      inputType: "text",
      cellRenderer: (row) => currencyFormat(row.opportunityAmount),
    },
    {
      dataField: "opportunityCount",
      text: "Opportunity Count",
      sort: true,
      width: 120,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col),
    },
    {
      dataField: "source",
      text: "Source",
      sort: true,
      width: 120,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col),
    },
    {
      dataField: "createdBy",
      text: "Created By",
      sort: true,
      width: 120,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col),
    },
    {
      dataField: "createdDate",
      text: "Created Date",
      sort: true,
      width: 120,
      show: true,
      inputType: "date",
      cellRenderer: (row, col) => formatter(row, col, "date"),
    },
    {
      dataField: "modifiedBy",
      text: "Modified By",
      sort: true,
      width: 120,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col),
    },
    {
      dataField: "modifiedDate",
      text: "Modified Date",
      sort: true,
      width: 120,
      show: true,
      inputType: "date",
      cellRenderer: (row, col) => formatter(row, col, "date"),
    },
  ];

  const onHandleSort = (filter, hasColFilter) => {
    setFilters(filter);
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setFilters(filter);
      let colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    setFilters(filter);
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setFilters(filter);
      let colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      setFilters(filter);
      onPageChange(filter);
    }
  };

  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      const filter = { ...filters, filters: colFilter, currentPage: 1 };
      onSearchColumnFilters(filter);
      setFilters(filter);
    }
  };
  const handleFilterCancel = () => {
    refetch(true);
  };

  return (
    <div className="table-card scroll-table position-relative border-0 rounded pt-0">
      <ReactStrapTable
        id="providers-table"
        fixedColumn
        columns={columns}
        data={tableData}
        handleSort={onHandleSort}
        loading={loading}
        reset={reset}
        onFilterCancel={handleFilterCancel}
        onSearchColumnFilters={handleSearchColumnFilters}
        onPageSizeChange={onPageSizeChange}
        onExport={onExport}
        hasPagination
        onPageChange={onHandlePageChange}
        currentPage={filters.currentPage}
        totalRecords={totalSize}
        filters={filters}
        pageSize={filters.pageSize}
      />
    </div>
  );
};
export default ProvidersTable;
